'use client'
import { useRouter } from 'next/navigation'

import { EdsnText } from '@8percent/edsn-react'
import { EdsnIcon } from '@8percent/edsn-icons/react'

type Props = {
  title: string
  date: string
}

export default function ContentTitle(props: Props) {
  const router = useRouter()

  const back = () => {
    router.back()
  }

  return (
    <>
      <div className="mobileOnly">
        <div className="min-h-[80px] pt-[40px] px-[16px]">
          <EdsnText variant="heading-m-strong" as="div">
            {props.title}
          </EdsnText>
        </div>
        <hr className="m-0 border-0 h-px bg-[var(--color-bg-neutral-tertiary,#dee2e5)]" />
      </div>
      <div className="pcOnly">
        <div className="h-[68px] mt-20 mb-[17px]">
          <div className="flex items-center">
            <div className="w-9 flex items-center justify-center cursor-pointer" onClick={back}>
              <EdsnIcon name="arrow-bold-left" size={18} />
            </div>
            <EdsnText variant="heading-l-regular" as="div">
              {props.title}
            </EdsnText>
          </div>
        </div>
      </div>
    </>
  )
}
